/** Builds a "{licence type}-{year}.pdf"-style download filename, per ZP-19 AC3. */
export function buildCertificateFilename(licenceType: string, validityYear: string | number): string {
  const slug = licenceType
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");
  return `zenfresh-${slug}-${validityYear}.pdf`;
}
